// extracted by mini-css-extract-plugin
export default {"container":"style_container__cjdLU","image":"style_image__WV09R","text":"style_text__iOwBN"};